import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import {
    TourState, DepotState, ReportShiftState, ChecklistState,
    tourReducer, depotReducer, reportShiftReducer, checklistReducer
} from './reducers';
import { overviewOfflineHydrate, overviewOfflineSync } from './meta-reducers';

export interface OverviewState {
    tours: TourState;
    depots: DepotState;
    reportShifts: ReportShiftState;
    checklists: ChecklistState;
}

export const reducers: ActionReducerMap<OverviewState> = {
    tours: tourReducer,
    depots: depotReducer,
    reportShifts: reportShiftReducer,
    checklists: checklistReducer
};

export const metaReducers: MetaReducer<any>[] = [overviewOfflineSync, overviewOfflineHydrate];

export const getOverviewState = createFeatureSelector<OverviewState>('overview');
